import * as _ from "lodash";

import { LineChartProcessor } from "./Core";
import { ChartContextType } from "../../../../providers";
import { DataDescriptorEntity, LineData } from "@ctra/api";

export class SingleEntityLineChartProcessor extends LineChartProcessor {
  public identity = "SingleEntityLineChartProcessor";

  /**
   * Check if the legend is visible
   * @param {ChartContextType<LineData>["values"]["meta"]} meta
   * @param {ChartContextType<LineData>["values"]["series"]} series
   * @param {Record<string, DataDescriptorEntity>} variants
   * @returns {boolean}
   */
  public isLegendVisible(
    meta: ChartContextType<LineData>["values"]["meta"],
    series: ChartContextType<LineData>["values"]["series"],
    variants: Record<string, DataDescriptorEntity>
  ) {
    const seriesTypes = _.uniq(_.map(meta, "seriesType"));
    const isSeriesOnly = _.every(seriesTypes, (type) => type === "series");

    return _.size(this.getSeries(meta, series, variants)) > 1 || isSeriesOnly;
  }
}
